// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1dLSK","title":"Info_title__eodYY","selects":"Info_selects__3VX13","requiredAsterisk":"Info_requiredAsterisk__1lV8Z"};